import { useNavigate } from 'react-router-dom';
import axiosApi from '../../../../api/daonAxios';
import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import PATH from '../../../../constants/url';
import ToastPopup from '../../../../components/comm/ToastPopup';
import { getDpSnsExists, getDpSnsSignin } from '../../../../assets/js/comm';
import CODE from '../../../../constants/code';
import MSG from '../../../../constants/message';
import URL from '../../../../constants/url';

const AppleRedirectPage = () => {
  const navigate = useNavigate();
  const isProcessing = useRef(false);
  // 토스트메시지
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const [sec, setSec] = useState(3);

  const [redirecting, setRedirecting] = useState(false);
  const [baseMsg, setBaseMsg] = useState('');

  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);
  const clearTimers = () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      intervalRef.current = null;
      timeoutRef.current = null;
  };
  // 공통 카운트다운 시작 함수
  const startRedirect = (message, seconds = 3) => {
      clearTimers();
      setBaseMsg(message);
      setSec(seconds);
      setToast(true);
      setRedirecting(true);

      intervalRef.current = setInterval(() => {
          setSec((s) => (s > 0 ? s - 1 : 0));
      }, 1000);

      timeoutRef.current = setTimeout(() => {
          navigate(PATH.LANDING, { replace: true });
      }, seconds * 1000);
  };

  const authCode = useMemo(() => {
    return new window.URL(window.location.href).searchParams.get('code');
  }, []);

  const oauthLogin = useCallback(async (code) => {
    if (isProcessing.current) return;

    isProcessing.current = true;

    try {
      const res = await axiosApi.post("/oauth/apple", { code });
      console.log('애플 토큰을 넘겨줘 : ', res);

        const email = res.data.result.tokens.email;
        const idToken = res.data.result.tokens.idToken;
        sessionStorage.setItem('sns_token', idToken);
        sessionStorage.setItem('sns_email', email);

        getDpSnsExists('apple', idToken)
            .then(async (res) => {
                //false = 가입 안되어있음 or 연동 안되어있음
                if(!res) {
                    //구글 + 애플은 idToken이 accessToken 역할을 함
                    navigate(PATH.IDENTITY, { replace: true, state: { provider : 'APPLE', accessToken: idToken , email : email } });
                } else {

                     const pushToken = sessionStorage.getItem('pushToken') || '';

                    //구글 + 애플은 idToken이 accessToken 역할을 함
                    const signRes = await getDpSnsSignin({sns : 'apple', idToken : idToken, pushToken : pushToken});

                    if (signRes?.accessToken !== undefined && signRes?.accessToken !== "") {
                        const jToken = signRes?.accessToken;
                        const refreshToken = signRes?.refreshToken;
                        const requestLoginUrl = "/signup/loginUser"; //"/signup/user";

                        const requestOptions = {
                            headers: {
                                Authorization: `Bearer ${jToken}`,
                            }
                            , params: {
                                refreshToken: refreshToken
                            }
                        }

                        await axiosApi.post(requestLoginUrl, {}, requestOptions)
                            .then((res) => {
                                if (Number(res.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
                                    const iitpUser = res.data.result.iitpUser;
                                    sessionStorage.removeItem("targetHsptl");//병원케어 메뉴 초기화
                                    sessionStorage.setItem('loginUser', JSON.stringify(iitpUser));
                                    localStorage.setItem('jToken', jToken);
                                    localStorage.setItem("IITP_CRTFC_TKN", refreshToken);
                                    if( iitpUser.usrSeCd !== '17') {
                                        if (iitpUser.usrHsptlMap.length > 0) {
                                            // 정상케이스
                                            navigate(PATH.HOME_MAIN);
                                        } else {
                                            // 해당부분은 맵핑된 병원이 없을 경우, 대표병원이 없을 경우, 병원연결 페이지가 뜨도록 조정해야함.
                                            navigate(PATH.HOSPITAL_LINK);
                                        }
                                    } else {
                                        //해외비대면인 경우
                                        navigate(URL.CONTACTLESS_MAIN);
                                    }
                                } else {
                                    startRedirect(MSG.ERR_PSSUSR+"\n사용자의 "+MSG.ERR_AUTH);
                                }
                            })
                            .catch((err) => {
                                console.log(" ================> RCV_ERROR_SERVER ", err);
                            })

                    } else { // sns 경우는 일반적으로 이쪽을 타지 않는다..
                        alert(MSG.ERR_PSSUSR + "\n사용자의 " + MSG.ERR_AUTH);
                    }
                }
            })
            .catch( (err) => {
                alert(err)
                if(err.response.status === Number(CODE.RCV_BAD_UNAUTH)) {
                }
            });
    } catch (err) {
      console.error("api/oauth/apple 호출 중 오류 : ", err);
    } finally {
      isProcessing.current = false;
    }
  }, []);

  useEffect(() => {
    if (authCode) {
      oauthLogin(authCode);
    }
  }, [authCode, oauthLogin]);

  return (
      <>
          <div>애플 로그인 중입니다...</div>
        {toast && (
            <ToastPopup
                setToast={setToast}
                position={"center"}
                message={toastMessage}
            />
        )}
      </>
  );
};

export default AppleRedirectPage;
